module.exports = __webpack_public_path__ + "static/media/externalModem.41ef21f4.png";